export default "__VITE_ASSET__DShfDI5V__"